import { useEffect } from 'react';

/**
 * Custom hook to raise an event when the browser window closes
 * @param handler Event to run
 */
export default function useBeforeUnload(handler: () => void) {
  useEffect(() => {
    const onbeforeunloadFn = () => {
      handler();
    };

    window.addEventListener('beforeunload', onbeforeunloadFn);
    return function cleanup() {
      window.removeEventListener('beforeunload', onbeforeunloadFn);
    };
  }, [handler]);
}
